import { render, staticRenderFns } from "./AddComponent.vue?vue&type=template&id=175325b5&"
import script from "./AddComponent.vue?vue&type=script&lang=ts&"
export * from "./AddComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AddComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddComponent.vue"
export default component.exports